import React from "react";
import Gauge from "./Gauge";
import { ResponsivePieCanvas } from "@nivo/pie";
import { Numeral } from "react-numeral";
import Image from "../../Tags/Image";

export default function WebTraffic({ data = {} }) {
  const pieSettings = {
    theme: {
      legends: {
        text: {
          fontSize: 12,
        },
      },
      tooltip: {
        container: {
          fontSize: "12px",
        },
      },
    },
    margin: { top: 10, right: 170, bottom: 10, left: 10 },
    innerRadius: 0.5,
    padAngle: 0,
    cornerRadius: 0,
    activeOuterRadiusOffset: 8,
    borderWidth: 0,
    borderColor: {
      from: "color",
      modifiers: [["darker", 0.2]],
    },
    arcLinkLabelsSkipAngle: 360, // Setting a high skip angle effectively hides all link labels
    arcLinkLabelsThickness: 0, // Set thickness to 0 to hide the lines
    arcLinkLabelsColor: { from: "color" },
    arcLabelsSkipAngle: 10,
    arcLabelsTextColor: {
      from: "color",
      modifiers: [["darker", 2]],
    },

    legends: [
      {
        anchor: "right",
        direction: "column",
        justify: false,
        translateX: 120,
        translateY: 0,
        itemsSpacing: 14,
        itemWidth: 100,
        itemHeight: 10,
        itemTextColor: "var(--gray-600)",
        itemDirection: "left-to-right",
        itemOpacity: 1,
        symbolSize: 10,
        symbolShape: "circle",

        effects: [
          {
            on: "hover",
            style: {
              itemTextColor: "#000",
            },
          },
        ],
      },
    ],
  };
  return (
    <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4  py-2 px-4">
      <h3 className="text-gray-900 my-2 font-bold">Website Traffic</h3>

      <div className="flex mb-2 space-x-4 px-4 -mx-4 mobile:block mobile:mx-0 mobile:space-x-0 mobile:px-0">
        <div className="w-6/12 mobile:w-full mobile:mb-3">
          <div className="border rounded-[14px] overflow-hidden border-gray-200  bg-gray-50 relative mt-4 p-4">
            <span className="text-[12px] capitalize whitespace-pre mb-4 leading-none block text-sm">
              Monthly Visitors
            </span>
            <div className="flex justify-between items-center">
              <Numeral
                className="text-gray-900 font-bold leading-none uppercase text-3xl"
                value={data?.monthly_visitors}
                format={"0.[0]a"}
              />
              <span className="inline-flex space-x-1 ml-3 ">
                <Image className="no-invert"
                  src={
                    data?.visitor_mom_pct < 0
                      ? "/images/ext/companyinfo/downtrend.svg"
                      : "/images/ext/companyinfo/uptrend.svg"
                  }
                />
                <span
                  className={`${data?.visitor_mom_pct < 0 ? "text-error-600" : "text-success-500"} text-sm`}
                >
                  {data?.visitor_mom_pct}%
                </span>
              </span>
            </div>
            <div className="mt-3">
              <Image
                className="w-full no-invert"
                src={
                  data?.visitor_mom_pct < 0
                    ? "/images/ext/companyinfo/downtrend-chart.svg"
                    : "/images/ext/companyinfo/uptrend-chart.svg"
                }
              />
            </div>
          </div>
        </div>
        {(data?.source?.direct_pct ||
          data?.source?.paid_referral_pct ||
          data?.source?.referral_pct ||
          data?.source?.search_pct) && (
          <div className="w-6/12 mobile:w-full">
            <div className="border rounded-[14px]  border-gray-200  bg-gray-50 relative mt-4 p-2">
              <div className="h-[166px]">
                <ResponsivePieCanvas
                  data={[
                    {
                      id: "Direct",
                      label: "Direct",
                      value: Number(data?.source?.direct_pct).toFixed(1),
                    },
                    {
                      id: "Paid Referral",
                      label: "Paid Referral",
                      value: Number(data?.source?.paid_referral_pct).toFixed(1),
                    },
                    {
                      id: "Referral",
                      label: "Referral",
                      value: Number(data?.source?.referral_pct).toFixed(1),
                    },
                    {
                      id: "Search",
                      label: "Search",
                      value: Number(data?.source?.search_pct).toFixed(1),
                    },
                  ]}
                  {...pieSettings}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
